import { Svg, Path } from '@react-pdf/renderer';
const Case = () => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <Path
      d="M4 20C3.45 20 2.979 19.804 2.588 19.412C2.196 19.021 2 18.55 2 18V6C2 5.45 2.196 4.979 2.588 4.588C2.979 4.196 3.45 4 4 4H10L12 6H20C20.55 6 21.021 6.196 21.413 6.588C21.804 6.979 22 7.45 22 8H4V18L6.4 10H23.5L20.925 18.575C20.792 19.008 20.546 19.354 20.188 19.613C19.829 19.871 19.433 20 19 20H4Z"
      fill="#1E9435"
    />
  </Svg>
);

export default Case;
